import Axios, { Response } from "../util/Axios";

const OrderHistoryController = {
  getCompletedOrders: async (oParams: any): Promise<Response> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_URL +
        "/obigo/orderhistory/getCompletedOrders";
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[주문내역 불러오기 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  historyDetail: async (oParams: any): Promise<Response> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_URL + "/obigo/orderhistory/historyDetail";
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[주문내역 영수증 불러오기 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  deleteOrderFromView: async (oParams: any): Promise<Response> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_URL +
        "/obigo/orderhistory/deleteOrderFromView";
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[주문내역 삭제 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
};
export default OrderHistoryController;
